import axios from './http';
import { CancelTokenSource } from 'axios';
import {
  CollectiveBillCreationRequest,
  CollectiveBillDataWrapperDto,
  CollectiveBillProofListRequest,
  CollectiveBillResponse
} from 'ts-types/api.types';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/collective-bill`;

export const getCollectiveBillDataForGuarantor = (guarantorId: number, source: CancelTokenSource): Promise<CollectiveBillDataWrapperDto> => {
  return axios
      .get(`${apiUri}/guarantor/${guarantorId}/open-treatments`, { cancelToken: source.token })
      .then(response => response.data);
}

export const collectiveBill = (guarantorId: number, creationRequest: Partial<CollectiveBillCreationRequest>, source: CancelTokenSource): Promise<CollectiveBillResponse> => {
  return axios
      .post(`${apiUri}/guarantor/${guarantorId}`, creationRequest, { cancelToken: source.token })
      .then(response => response.data);
}

export const collectiveBillProofList = (guarantorId: number, proofListRequest: Partial<CollectiveBillProofListRequest>, source: CancelTokenSource): Promise<CollectiveBillResponse> => {
  return axios
      .post(`${apiUri}/guarantor/${guarantorId}/proof-list`, proofListRequest, { cancelToken: source.token })
      .then(response => response.data);
}

export const getCollectiveBillPdf = (billPdfId: string, billPdfName: string): string => {
  return `${baseUrl}/2213ffa1982347769a018c449ca349fa/${billPdfId}/${billPdfName}`
};

export const getCollectiveBillProofListPdf = (billPdfId: string, billPdfName: string): string => {
  return `${baseUrl}/14bee6831ba7456ba74232cb0522aef3/${billPdfId}/${billPdfName}`
};
